var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMa = function SvgMa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c1272d",
    d: "M640 0H0v480h640z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 179.452l-35.574 109.496 93.12-67.647H262.453l93.122 67.648z",
    fill: "none",
    stroke: "#006233",
    strokeWidth: 11.704
  })));
};
export default __webpack_public_path__ + "assets/6e255873b63b606b9cce620d1e1979c1.svg";
export { SvgMa as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ma.svg